import React, { useEffect } from "react";
import { Typography } from "@mhome/ui";
import { useIsDarkMode } from "../lib/utils";
import Button1Widget from "./widget/button-1";
import { getDetailWidgetComponent } from "./detail-widget-registry";
import * as Mui from "@mui/material";
import * as ReactLib from "react";

// Detail widget component for detail dialog - similar to MainWidget but without title click functionality
const DetailWidget = React.memo(
  ({ widget, onValueUpdate, onStateUpdate, onTriggerEvent }) => {
    let DataWidgetComponent;

    const actualMode = useIsDarkMode();
    const isDynamic = !!widget.componentCode;

    // Create minimal theme object for dynamic components (backward compatibility)
    const minimalTheme = { mode: actualMode };

    switch (widget.skin) {
      case "default.button":
        return <Button1Widget widget={widget} onValueUpdate={onTriggerEvent} />;
      default:
        DataWidgetComponent = getDetailWidgetComponent(
          widget.skin,
          widget.componentCode
        );
        if (DataWidgetComponent) {
          if (isDynamic) {
            return (
              <DataWidgetComponent
                widget={widget}
                onValueUpdate={onValueUpdate}
                onStateUpdate={onStateUpdate}
                onTriggerEvent={onTriggerEvent}
                theme={minimalTheme}
                Mui={Mui}
                React={ReactLib}
              />
            );
          } else {
            return (
              <DataWidgetComponent
                widget={widget}
                onValueUpdate={onValueUpdate}
                pattern={widget.pattern}
              />
            );
          }
        }
        return (
          <div className="p-4">
            <Typography color="error">
              Unknown widget type: {widget.skin}
            </Typography>
          </div>
        );
    }
  },
  (prevProps, nextProps) => {
    // Only compare if the widget object is the same reference
    return prevProps.widget === nextProps.widget;
  }
);

DetailWidget.displayName = "DetailWidget";

export default DetailWidget;
